import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@repo/ui";
import { getMedia } from "../../../utils/indexedDB";
import PageContainer from "../../../components/PageContainer/PageContainer";
import Confetti from "../../../components/Confetti/Confetti";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import StepIndicator from "../../../components/StepIndicator/StepIndicator";
import { useAppDispatch, useAppSelector } from "../../../hooks/useAppDispatch";
import { RootState } from "../../../redux/store";
import { fetchAndLoadGiftTable } from "../../../redux/slices/guestsGiftTableSlice";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import { useMediaQuery } from "react-responsive";

const LOCALE = "modules_Guests_pages_GuestPaymentSuccess";

const GuestPaymentSuccess: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [photo, setPhoto] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const giftTable = useAppSelector((state: RootState) => state.guestGiftTable);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    (async () => {
      const savedPhoto = await getMedia("dedicationMedia");
      if (savedPhoto) {
        setPhoto(savedPhoto);
      }
    })();
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(fetchAndLoadGiftTable(id));
    }
  }, [dispatch, id]);

  const handleReturnToGiftTable = () => {
    navigate(`/guests/gifttable/${id}`);
  };

  // Use fallback image if no saved photo is available
  const imageUrl =
    photo ||
    "https://public-bucket-prd-ee73a5e.s3.us-east-1.amazonaws.com/assets/giftbox-watercolor.avif";

  return (
    <PageContainer>
      <div className="mt-16"></div>
      {!isMobile && (
        <StepIndicator
          steps={[t("step_message"), t("step_summary"), t("step_payment")]}
          currentStep={3}
          progressPercentage={100}
        />
      )}
      <Confetti />
      <AnimatedCard
        title={t("giftSuccessMessage", { name: giftTable.amphitryon })}
        className="bg-white max-w-lg w-full text-center"
      >
        <div className="flex justify-center mb-4">
          <div className="relative w-64 h-64 rounded-full overflow-hidden">
            <img
              src={imageUrl}
              alt="Event"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <Button
          label={t("returnToGiftTable")}
          onClick={handleReturnToGiftTable}
          type="primary"
          className="bg-primary text-white px-6 py-3 rounded-md shadow-md"
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withTranslations(LOCALE)(GuestPaymentSuccess);
